import React, { useImperativeHandle, useRef } from "react";
import { Textarea as BaseTextarea, TextareaProps as BaseTextareaProps } from "./ui/textarea";

type TextareaProps = BaseTextareaProps & {
    autoHeight?: boolean;
    onlyOnFocus?: boolean;
};
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    function ({ onlyOnFocus, autoHeight = false, ...props }, ref) {
        const thisRef = useRef<HTMLTextAreaElement>(null);
        useImperativeHandle(ref, () => thisRef.current);
        return <BaseTextarea
            ref={(element) => {
                const handleInput = () => {
                    if (!thisRef.current) return;
                    thisRef.current.style.height = "auto";
                    thisRef.current.style.height = thisRef.current.scrollHeight + "px";
                };
                const handleFocus = () => {
                    if (onlyOnFocus) handleInput();
                };

                const handleBlur = () => {
                    if (!thisRef.current) return;
                    if (onlyOnFocus) thisRef.current.style.height = "auto";
                };

                if (thisRef.current) {
                    thisRef.current.removeEventListener("input", handleInput);
                    thisRef.current.addEventListener("focus", handleFocus);
                    thisRef.current.addEventListener("blur", handleBlur);
                }
                thisRef.current = element;
                if (!element) return;
                element.style.overflowY = "hidden";
                element.addEventListener("input", handleInput);

                element.addEventListener("focus", handleFocus);
                element.addEventListener("blur", handleBlur);

                // Call right away to update height based on initial text
                handleInput();
            }}
            {...props}
        />;
    }
);

export { Textarea };